export type RuntimeConfig = {
  assetsBaseUrl?: string;
};

let runtimeConfig: RuntimeConfig = {};
let hasLoaded = false;

export const loadRuntimeConfig = async (): Promise<void> => {
  if (hasLoaded) return;
  hasLoaded = true;
  try {
    const response = await fetch('/config.json', { cache: 'no-store' });
    if (!response.ok) {
      runtimeConfig = {};
      return;
    }
    const data = (await response.json()) as RuntimeConfig;
    runtimeConfig = data ?? {};
  } catch {
    runtimeConfig = {};
  }
};

export const getRuntimeConfig = (): RuntimeConfig => runtimeConfig;
